"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var react_1 = __importStar(require("react"));
var Cores_1 = require("../Cores/Cores");
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Divider_1 = require("../Divider/Divider");
var Icone_1 = require("../Icone/Icone");
var globalMu_1 = __importDefault(require("../../globalMu"));
var estiloTooltip = require("./Tooltip.module.scss");
var Tooltip = function (_a) {
    var _b = _a.estiloTooltip, estilo = _b === void 0 ? "azulMU" : _b, titulo = _a.tituloTooltip, _c = _a.descricaoTooltip, descricao = _c === void 0 ? "Descrição do Tooltip" : _c, _d = _a.posicaoTooltip, posicao = _d === void 0 ? "direita" : _d, children = _a.children, mostrarPonteiroAjuda = _a.mostrarPonteiroAjuda, _e = _a.mostrarDivider, mostrarDivider = _e === void 0 ? true : _e, style = _a.style;
    var _f = (0, react_1.useState)(false), onSobrepor = _f[0], setOnSobrepor = _f[1];
    var _g = (0, react_1.useState)(posicao), posicaoCalculada = _g[0], setPosicaoCalculada = _g[1];
    var tooltipRef = (0, react_1.useRef)(null);
    var obterCores = function (estilo) {
        switch (estilo) {
            case "azulMU":
                return Cores_1.Cores.CoresIdentidadeMU.azulMu;
            case "cinzaMU":
                return Cores_1.Cores.GradacaoNeutros.CinzaFillMU200;
            case "error":
                return Cores_1.Cores.MensagensDoSistema.VermelhoMU;
            case "warning":
                return Cores_1.Cores.MensagensDoSistema.LaranjaMU;
            case "info":
                return Cores_1.Cores.GradacaoPrimaria.AzulMedioMU600;
            case "success":
                return Cores_1.Cores.MensagensDoSistema.VerdeMU;
            default:
                return Cores_1.Cores.GradacaoNeutros.CinzaFillMU200;
        }
    };
    var calculatePosition = function () {
        var _a;
        if (tooltipRef.current) {
            var tooltipRect = tooltipRef.current.getBoundingClientRect();
            var parentRect = (_a = tooltipRef.current.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (!parentRect)
                return;
            var spaceRight = window.innerWidth - parentRect.right;
            var spaceLeft = parentRect.left;
            var spaceTop = parentRect.top;
            var spaceBottom = window.innerHeight - parentRect.bottom;
            if (spaceRight >= tooltipRect.width) {
                setPosicaoCalculada("direita");
            }
            else if (spaceLeft >= tooltipRect.width) {
                setPosicaoCalculada("esquerda");
            }
            else if (spaceTop >= tooltipRect.height) {
                setPosicaoCalculada("superior");
            }
            else if (spaceBottom >= tooltipRect.height) {
                setPosicaoCalculada("inferior");
            }
        }
    };
    (0, react_1.useEffect)(function () {
        calculatePosition();
    }, [onSobrepor]);
    var TooltipComponente = (react_1.default.createElement("div", { ref: tooltipRef, className: "".concat(estiloTooltip.tooltip, " ").concat(estiloTooltip[posicaoCalculada], " ").concat(estiloTooltip[estilo]) },
        react_1.default.createElement("div", { className: "".concat(estiloTooltip.seta, " ").concat(estiloTooltip[posicaoCalculada], " ").concat(estiloTooltip[estilo]) },
            react_1.default.createElement(Icone_1.Icone, { nome: "seta_polygona", cor: obterCores(estilo), largura: "30px", altura: "30px" })),
        react_1.default.createElement("div", { className: "".concat(estiloTooltip.conteudo, " ").concat(estiloTooltip[estilo]) },
            globalMu_1.default.isNotNullOrEmptyOrUndefined(titulo) &&
                typeof titulo === "string" ? (react_1.default.createElement(Corpo_1.Corpo, { tipo: "body2", negrito: 700, cor: Cores_1.Cores.GradacaoPrimaria.AzulEscuroMU900 }, titulo)) : (titulo),
            mostrarDivider && react_1.default.createElement(Divider_1.Divider, null),
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "body3", negrito: 400, cor: estilo === "cinzaMU"
                    ? Cores_1.Cores.GradacaoPrimaria.AzulEscuroMU900
                    : Cores_1.Cores.CoresIdentidadeMU.brancoMu }, descricao))));
    return (react_1.default.createElement("div", { className: estiloTooltip.tooltipContainer, style: __assign(__assign({}, style), { cursor: "".concat(mostrarPonteiroAjuda ? "help" : "default") }), onMouseLeave: function () { return setOnSobrepor(false); }, onMouseEnter: function () { return setOnSobrepor(true); } },
        children,
        onSobrepor && TooltipComponente));
};
exports.Tooltip = Tooltip;
